import type { ReactNode } from 'react';
import { CountBadge } from '~/components/ui/CountBadge';

type SummaryPanelProps = {
  title: string;
  count: number;
  icon: ReactNode;
  children: ReactNode;
};

export function SummaryPanel({
  title,
  count,
  icon,
  children,
}: Readonly<SummaryPanelProps>) {
  return (
    <section className="flex min-h-0 flex-col overflow-hidden rounded-xl border border-neut-border bg-neut-bg-alt">
      <header className="flex items-center gap-2 border-b border-neut-border bg-neut-50 px-4 py-3">
        <span aria-hidden="true" className="text-neut-500">
          {icon}
        </span>
        <h3 className="text-sm font-semibold text-neut-prim">{title}</h3>
        <CountBadge count={count} className="ml-auto" />
      </header>
      <div className="flex-1 overflow-y-auto p-2">{children}</div>
    </section>
  );
}
